export enum QueryKeys {
  GET_ROLES = 'GET_ROLES',
  GET_ROLE = 'GET_ROLE',
  CREATE_ROLE = 'CREATE_ROLE',
  UPDATE_ROLE = 'UPDATE_ROLE',
  DELETE_ROLE = 'DELETE_ROLE',
  INVITE_USER = 'INVITE_USER',
  GET_USER_ME = 'GET_USER_ME',
  GET_ORGANIZATION_TOKENS_AVAILABLE = 'GET_ORGANIZATION_TOKENS_AVAILABLE',
  GET_USERS_ALL = 'GET_USERS',
  GET_BUSINESSES_ALL = 'GET_BUSINESS',
  GET_BUSINESS_BY_ID = 'GET_BUSINESS_BY_ID',
  SUMMARY_MOVEMENTS_FROM_TO = 'SUMMARY_MOVEMENTS_FROM_TO',
  GET_ADMINISTRATION_DASHBOARD = 'GET_ADMINISTRATION_DASHBOARD',
  GET_DOCUMENTS_TYPES = 'GET_DOCUMENTS_TYPES',
  GET_ACCOUNTS_TYPES = 'GET_ACCOUNTS_TYPES',
  BANK_TRANSACTIONS = 'BANK_TRANSACTIONS',
  ADMIN_TRANSACTIONS = 'ADMIN_TRANSACTIONS',
  DIGITAL_PAYMENTS_SUMMARY = 'DIGITAL_PAYMENTS_SUMMARY',
  DIGITAL_PAYMENTS_DETAIL = 'DIGITAL_PAYMENTS_DETAIL',
  LIBRO_DIARIO = 'LIBRO_DIARIO',
  LIBRO_MAYOR = 'LIBRO_MAYOR',
  COMPROBANTES = 'COMPROBANTES',
  GET_PAYMENT_CARDS = 'GET_PAYMENT_CARDS',
  GET_PAYMENT_PLANS = 'GET_PAYMENT_PLANS',
  GET_ORGANIZATION_SUBSCRIPTIONS = 'GET_ORGANIZATION_SUBSCRIPTIONS',
  GET_ADDONS = 'GET_ADDONS',
  GET_ADDON_SUBSCRIPTIONS = 'GET_ADDON_SUBSCRIPTIONS',
  GET_PAYMENTS = 'GET_PAYMENTS',
  GET_ORGANIZATION_SUBSCRIPTION_STATUS = 'GET_ORGANIZATION_SUBSCRIPTION_STATUS',
  GET_TICKETS = 'GET_TICKETS',
  GET_MY_TICKETS = 'GET_MY_TICKETS',
  GET_TICKET_BY_ID = 'GET_TICKET_BY_ID',
  GET_MONTHLY_SUMMARY = 'GET_MONTHLY_SUMMARY',
  GET_INVENTORY_WAREHOUSES = 'GET_INVENTORY_WAREHOUSES',
  GET_INVENTORY_ITEMS = 'GET_INVENTORY_ITEMS',
  GET_INVENTORY_STOCK = 'GET_INVENTORY_STOCK',
  GET_INVENTORY_MOVEMENTS = 'GET_INVENTORY_MOVEMENTS',
  GET_INVENTORY_RECIPE_BY_ITEM = 'GET_INVENTORY_RECIPE_BY_ITEM',
  GET_INVENTORY_RECIPE_COMPONENTS = 'GET_INVENTORY_RECIPE_COMPONENTS',
  GET_BANK_ACCOUNT_BANKS = 'GET_BANK_ACCOUNT_BANKS',
  GET_BANK_ACCOUNT_INITIAL_BALANCES = 'GET_BANK_ACCOUNT_INITIAL_BALANCES'
}
